export default "__VITE_PUBLIC_ASSET__19d6c0a3__"